var exports = {
  "button": "MediaPlaybackRate.module__button___b3prd1",
  "small": "MediaPlaybackRate.module__small___b3prd1",
  "medium": "MediaPlaybackRate.module__medium___b3prd1",
  "large": "MediaPlaybackRate.module__large___b3prd1",
  "active": "MediaPlaybackRate.module__active___b3prd1",
  "label": "MediaPlaybackRate.module__label___b3prd1",
};

__webpack_require__.r(module.exports = exports);
